export var FlexBoxAlignItems;
(function (FlexBoxAlignItems) {
    /**
     * Items are aligned toward the start of the flex-direction.<br />
     * <b>Note:</b> Corresponds to `flex-start`.
     */
    FlexBoxAlignItems["Start"] = "Start";
    /**
     * Items are centered.<br />
     * <b>Note:</b> Corresponds to `center`.
     */
    FlexBoxAlignItems["Center"] = "Center";
    /**
     * Items are aligned toward the end of the flex-direction.<br />
     * <b>Note:</b> Corresponds to `flex-end`.
     */
    FlexBoxAlignItems["End"] = "End";
    /**
     * Items are aligned by their baseline.<br />
     * <b>Note:</b> Corresponds to `baseline`.
     */
    FlexBoxAlignItems["Baseline"] = "Baseline";
    /**
     * Items are stretched to fill the container.<br />
     * <b>Note:</b> Corresponds to `stretch`.
     */
    FlexBoxAlignItems["Stretch"] = "Stretch";
})(FlexBoxAlignItems || (FlexBoxAlignItems = {}));
